export default {
  applyTrial: {
    freeTrial: '免费试用',
    dialog: {
      title: '申请试用',
      forbiden: '暂无权限',
      desc: '为了便于我们更好的提供服务，在正式开通试用服务前，请告诉我们:',
      cancel: '取消',
      applyApproved: '申请通过',
      form: {
        pleaseInput: '请输入',
        empty: '必填项',
        atleast: '至少选择一个选项',
        urlValidator: {
          errorInfo: 'url格式有误',
        },
        full_name: {
          label: '联系人名字',
        },
        phone: {
          label: '联系电话',
        },
        region: {
          label: '国家或地区',
        },
        company: {
          label: '公司',
        },
        company_type: {
          label: '公司类型',
        },
        job_title: {
          label: '职位',
        },
        product_type: {
          label: '推广产品类型',
        },
        app_url: {
          label: '主要产品商店链接',
          placeholder: '产品链接',
        },
        contact_account: {
          label: '联系方式和帐号',
        },
        team_size: {
          label: '创意团队规模',
        },
        isMtg: {
          label: '是否已与Mintegral合作？',
        },
        interested_in: {
          label: '感兴趣的功能',
        },
        mtg_name: '我的Mintegral账号',
        interesting_gameplay: {
          label: '感兴趣的创意类型',
        },
        interesting_videos: {
          label: '感兴趣的视频功能',
        },
        message: {
          label: '请描述素材制作希望实现的效果？',
        },
      },
    },
    trialSuccess: {
      tips: '已为您开通Playturbo试用服务，有效期{days} 天（到期时间：{expired_date})，快开始您的创意制作之旅吧！',
      message: '已成功开通试用',
      ok: '我知道了',
    },
    form: {
      companyType: {
        band: '品牌主',
        agent: '广告代理商',
        media: '媒体',
        game: '游戏',
        app: 'APP',
        adv: '广告主',
        dev: '开发者',
        other: '其他',
      },
      connectType: {
        wechat: '微信',
        skype: 'Skype',
        slack: 'Slack',
        telegram: 'Telegram',
        other: 'Other',
      },
      willFeature: {
        pl: '可玩广告制作',
        video: '视频广告制作',
        plvideo: '可玩+视频广告制作',
      },
      willVideo: {
        crossover: '视频片段混剪',
        mlang: '视频多语言制作',
        mtsize: '视频多尺寸制作',
        ai: '视频Ai消除',
      },
      ismtg: {
        yes: '是',
        no: '否',
      },
      productType: {
        casual: '休闲',
        hypercasual: '超休闲',
        mid: '中重度',
        casino: '赌博博彩',
        playtoearn: '游戏网赚',
        entertainment: '娱乐',
        social: '社交',
        utility: '实用工具',
        education: '教育',
        finance: '金融',
        travel: '出行旅游',
        ecommerce: '电商',
        other: '其他',
      },
    },
  },
  totop: {
    contact: {
      title: '联系我们',
      desc: '有问题请在此处留言，并备注您的联系方式和账号。<br/>或者直接发邮件到 <a href="mailto:playturbo@mindworks-creative.com">playturbo@mindworks-creative.com</a> <br/>我们将在收到消息后尽快与您联系！',
      dialog: {
        input: {
          placeholder: '请描述您的问题',
        },
        cancel: '取消',
        submit: '提交',
        success: '留言成功',
      },
    },
    QRCode: {
      title: '微信扫码咨询客服',
    },
  },
}
